import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { extractBillingApiMessage } from "./billingOptionForm";

export function useDeleteBillingOption() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, error } = useMutation({
    mutationKey: ["admin", "expert-plans", "billing-options", "delete"],
    mutationFn: ({ planId, billingOptionId }: { planId: number; billingOptionId: number }) => {
      return api.admin.expertBilling.deleteBillingOption({
        params: { plan: planId, billingOption: billingOptionId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "expert-plans"] });
      toaster.create({
        title: "Billing option deleted",
        type: "success",
      });
    },
    onError: (err: Error) => {
      toaster.create({
        title: "Failed to delete billing option",
        description: extractBillingApiMessage(err) ?? "An unexpected error occurred",
        type: "error",
      });
      console.error("[useDeleteBillingOption] Error:", err);
    },
  });

  return { mutate, mutateAsync, isPending, error };
}

export default useDeleteBillingOption;
